(() => {
  const initialize = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-k17-data]').textContent);
    const track = root.querySelector('.k17-gallery__track');
    const slides = Array.from(track.querySelectorAll('.k17-gallery__slide'));
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-index]'));
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    let index = 0;
    const go = i => track.scrollTo({left: Math.max(0, Math.min(i, slides.length - 1)) * track.clientWidth, behavior: 'smooth'});
    const galleryState = () => {
      index = Math.round(track.scrollLeft / (track.clientWidth || 1));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      const counter = root.querySelector('[data-gallery-current]');
      if (counter) counter.textContent = String(index + 1);
    };
    thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => go(i)));
    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    track.addEventListener('scroll', galleryState, {passive:true});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();go(index + (event.key === 'ArrowRight' ? 1 : -1));}
    });
    const fieldsets = Array.from(root.querySelectorAll('[data-option-position]'));
    const form = root.querySelector('.k17-form');
    const button = form.querySelector('[name=add]');
    const notify = root.querySelector('[data-notify]');
    const status = root.querySelector('[data-cart-status]');
    let current = data.variants.find(v => v.id === data.selected) || data.variants[0];
    const update = (changeUrl = false) => {
      const values = fieldsets.map(field => field.querySelector('input:checked')?.value);
      if (fieldsets.length) current = data.variants.find(v => v.options.every((value, i) => value === values[i]));
      const available = Boolean(current?.available);
      form.querySelector('[name=id]').value = current?.id || '';
      button.disabled = !available;
      root.querySelector('[data-k17-add-label]').textContent = current ? (available ? data.strings.add : data.strings.soldOut) : data.strings.unavailable;
      root.querySelector('[data-k17-price]').innerHTML = current?.price || '—';
      const compare = root.querySelector('[data-k17-compare]');
      compare.hidden = !current?.compare;
      compare.innerHTML = current?.compare || '';
      const ctaPrice = root.querySelector('[data-k17-cta-price]');
      ctaPrice.hidden = !available;
      ctaPrice.innerHTML = current ? ' — ' + current.price : '';
      root.querySelector('[data-k17-stock]').dataset.available = String(available);
      root.querySelector('[data-k17-stock-text]').textContent = current ? (available ? data.strings.available : data.strings.soldOut) : data.strings.unavailable;
      notify.hidden = available || !current;
      delete notify.dataset.state;
      status.hidden = true;
      fieldsets.forEach((field, pos) => field.querySelectorAll('input').forEach(input => {
        const choice = values.slice(); choice[pos] = input.value;
        const optionVariant = data.variants.find(v => v.options.every((value,i) => value === choice[i]));
        input.nextElementSibling.dataset.available = String(Boolean(optionVariant?.available));
        input.nextElementSibling.dataset.stockLabel = data.strings.soldOut;
      }));
      if (current?.image) {
        const imageIndex = slides.findIndex(slide => slide.dataset.imageId === String(current.image));
        if (imageIndex >= 0) go(imageIndex);
      }
      if (changeUrl && current) {const url = new URL(location.href);url.searchParams.set('variant',current.id);history.replaceState({},'',url);}
    };
    fieldsets.forEach(field => field.addEventListener('change', () => update(true)));
    update();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!current?.available || button.disabled) return;
      button.disabled = true;
      root.querySelector('[data-k17-add-label]').textContent = data.strings.adding;
      status.hidden = true;
      try {
        const response = await fetch(data.addUrl, {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : data.strings.error);
        document.dispatchEvent(new CustomEvent('cart:open'));
        button.disabled = false;
        root.querySelector('[data-k17-add-label]').textContent = data.strings.add;
      } catch (error) {
        status.textContent = error.message || data.strings.error;
        status.hidden = false;
        button.disabled = false;
        root.querySelector('[data-k17-add-label]').textContent = data.strings.add;
      }
    });
    notify.addEventListener('submit', async event => {
      event.preventDefault();
      if (!current || !notify.reportValidity()) return;
      const submit = notify.querySelector('button');
      submit.disabled = true;
      delete notify.dataset.state;
      try {
        const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QeupfE',{
          method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},
          body:JSON.stringify({data:{type:'back-in-stock-subscription',attributes:{profile:{data:{type:'profile',attributes:{email:notify.elements.email.value}}},channels:['EMAIL']},relationships:{variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::'+current.id}}}}})
        });
        if (!response.ok) throw new Error('Subscription failed');
        notify.dataset.state = 'success';
      } catch {notify.dataset.state = 'error';}
      finally {submit.disabled = false;}
    });
  };
  const start = () => document.querySelectorAll('[data-k17-pdp]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();

